import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import Backend from 'i18next-http-backend';

import useLocalStore from 'src/store/useLocalStore';

import {
  isProdEnv,
  Language,
  pseudoizerLanguage,
} from 'src/models/Language.model';

const localLanguage = useLocalStore.getState().uiLanguage;

const i18nUI = i18n.createInstance();

const lng = localLanguage ?? Language.ENGLISH;

i18nUI
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: isProdEnv ? Language.ENGLISH : pseudoizerLanguage,
    debug: !isProdEnv,
    ns: ['translation'],
    lng,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    load: 'currentOnly',
  });

export default i18nUI;
